import {Model} from '@/models/Model'
import Helper from '../services/Helper.js'
import {DataArray, DataResource, FilterSet} from './Response'


export const UserConst = Object.freeze({
  ROLE_ADMIN: 1,
  ROLE_CEO: 2,
  ROLE_DIRECTOR: 5,
  ROLE_MANAGER: 10,
  ROLE_ACCOUNT: 15,
  ROLE_LOGISTIC: 17,
  ROLE_USER: 20,

  map(status: number): string {
    switch (status) {
      case UserConst.ROLE_ADMIN:
        return 'Admin'
      case UserConst.ROLE_CEO:
        return 'CEO'
      case UserConst.ROLE_DIRECTOR:
        return 'Director'
      case UserConst.ROLE_MANAGER:
        return 'Manager'
      case UserConst.ROLE_ACCOUNT:
        return 'Account'
      case UserConst.ROLE_LOGISTIC:
        return 'Logistic'
      case UserConst.ROLE_USER:
        return 'Sale'

      //รอจัดทริป
      //กำลังขนส่ง
      //
    }
    // debugger
    return ''//'ไม่ระบุ[' + status + ']'
  },
})


export class User extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  nickname: string | null
  employee_code: string | null
  picture: string | null
  signature: string | null
  tel: string | null
  department: string | null
  role: number | null
  password: string | null
  theme: string | null
  mode: string | null
  target_sale: number | null

  enabled: boolean | null

  getResourceURL(): string {
    return Helper.setting.user.getResourceAPI
  }

}

export class DataUsersArray extends DataArray {

  declare data: User[]
  filter: FilterUser = new FilterUser()
}


export class FilterUser {

  department: FilterSet = new FilterSet()
  role: FilterSet = new FilterSet()
}


export class DataUser extends DataResource {

  declare data: User

}
